import { Backdrop, Box, Button, Fade, Modal, Typography } from '@mui/material';
import { ModalType, UpdateRestaurantPublishStatus } from '@/types/index';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { printDisplayDate } from '@/utils/index';

const style = {
  position: 'absolute',
  top: '30%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 615,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

interface ModalRestaurantProps {
  openModal: boolean;
  type: ModalType;
  restaurantId: string;
  restaurantUpdatePublishStatusData: UpdateRestaurantPublishStatus;
  setRestaurantUpdatePublishStatusData: Dispatch<SetStateAction<UpdateRestaurantPublishStatus>>;
  setType: Dispatch<SetStateAction<ModalType>>;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
}

export const ModalChangeRestaurantStatus = (props: ModalRestaurantProps) => {
  const { openModal, setOpenModal, restaurantId, restaurantUpdatePublishStatusData, setRestaurantUpdatePublishStatusData, setType, type } = props;
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [temp, setTemp] = useState('');
  const [dateArray, setDateArray] = useState('');

  useEffect(() => {
    if (type === 'CANNOT_UPDATE_STATUS') {
      setTitle("Can't inactivate restaurant");
      setDescription(
        'The restaurant is scheduled to order on (' +
          dateArray +
          '). To inactivate this restaurant, try changing the restaurant scheduling or canceling all orders.'
      );
      setButtonText('OK');
      setTemp('#F44336');
    }
  }, [type, temp]);

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    if (restaurantUpdatePublishStatusData.state === 'error') {
      if (restaurantUpdatePublishStatusData.data) {
        setType('CANNOT_UPDATE_STATUS');
        setOpenModal(true);
        setRestaurantUpdatePublishStatusData({
          state: 'initial',
        } as UpdateRestaurantPublishStatus);

        const rawData = restaurantUpdatePublishStatusData.data;
        const dateList = Array.isArray(rawData) ? rawData.map((object: any) => object.date).sort() : [];
        dateList.sort();

        const displayDateList = dateList.map((date: string) => {
          return printDisplayDate(date);
        });
        setDateArray(displayDateList.join(', '));
      }
    }
  }, [restaurantUpdatePublishStatusData]);

  return (
    <Modal
      id={'modal-restaurant-' + restaurantId}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openModal}
      onClose={() => handleClose()}
      closeAfterTransition
      slots={{
        backdrop: Backdrop,
      }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openModal}>
        <Box sx={style}>
          <Typography id="transition-modal-title" variant="h5" component="h2">
            {title}
          </Typography>
          <Typography id="transition-modal-description" sx={{ mt: 2 }} style={{ color: '#212121' }}>
            {description}
          </Typography>
          <Button
            style={{ backgroundColor: temp, color: '#ffffff' }}
            sx={{ mt: 2 }}
            id={type?.toLowerCase()}
            onClick={() => {
              if (type === 'CANNOT_UPDATE_STATUS') handleClose();
            }}
          >
            {buttonText}
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};
